import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-3xl font-medium capitalize" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded"
}
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "mx-2 my-2 text-sm" }
const _hoisted_8 = { class: "block capitalize" }
const _hoisted_9 = { class: "block capitalize" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "block" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "text-3xl font-medium capitalize" }
const _hoisted_18 = { class: "flex items-center justify-between" }
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = { class: "text-3xl font-medium capitalize" }
const _hoisted_26 = { class: "mr-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_18809_4626)" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white",
      "fill-opacity": "0.01"
    }),
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_18809_4626)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0.5 9.89921C0.632608 9.89921 0.759785 9.95189 0.853553 10.0457C0.947322 10.1394 1 10.2666 1 10.3992V12.8992C1 13.1644 1.10536 13.4188 1.29289 13.6063C1.48043 13.7938 1.73478 13.8992 2 13.8992H14C14.2652 13.8992 14.5196 13.7938 14.7071 13.6063C14.8946 13.4188 15 13.1644 15 12.8992V10.3992C15 10.2666 15.0527 10.1394 15.1464 10.0457C15.2402 9.95189 15.3674 9.89921 15.5 9.89921C15.6326 9.89921 15.7598 9.95189 15.8536 10.0457C15.9473 10.1394 16 10.2666 16 10.3992V12.8992C16 13.4296 15.7893 13.9383 15.4142 14.3134C15.0391 14.6885 14.5304 14.8992 14 14.8992H2C1.46957 14.8992 0.960859 14.6885 0.585786 14.3134C0.210714 13.9383 0 13.4296 0 12.8992V10.3992C0 10.2666 0.0526784 10.1394 0.146447 10.0457C0.240215 9.95189 0.367392 9.89921 0.5 9.89921Z",
        fill: "white"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.646 11.8532C7.69245 11.8998 7.74762 11.9367 7.80837 11.9619C7.86911 11.9871 7.93423 12.0001 8 12.0001C8.06577 12.0001 8.13089 11.9871 8.19163 11.9619C8.25238 11.9367 8.30755 11.8998 8.354 11.8532L11.354 8.85321C11.4479 8.75932 11.5006 8.63198 11.5006 8.49921C11.5006 8.36643 11.4479 8.23909 11.354 8.14521C11.2601 8.05132 11.1328 7.99857 11 7.99857C10.8672 7.99857 10.7399 8.05132 10.646 8.14521L8.5 10.2922V1.49921C8.5 1.3666 8.44732 1.23942 8.35355 1.14565C8.25979 1.05188 8.13261 0.999207 8 0.999207C7.86739 0.999207 7.74021 1.05188 7.64645 1.14565C7.55268 1.23942 7.5 1.3666 7.5 1.49921V10.2922L5.354 8.14521C5.26011 8.05132 5.13278 7.99857 5 7.99857C4.86722 7.99857 4.73989 8.05132 4.646 8.14521C4.55211 8.23909 4.49937 8.36643 4.49937 8.49921C4.49937 8.63198 4.55211 8.75932 4.646 8.85321L7.646 11.8532Z",
        fill: "white"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_28 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_29 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_30 = { class: "w-full mt-4 table-fixed" }
const _hoisted_31 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_32 = { class: "px-2 py-2" }
const _hoisted_33 = { class: "px-2 py-2 capitalize" }
const _hoisted_34 = { class: "px-2 py-2" }
const _hoisted_35 = { class: "px-2 py-6 md:py-3" }
const _hoisted_36 = { class: "px-2 py-6 md:py-3" }
const _hoisted_37 = { class: "px-2 py-6 md:py-3" }
const _hoisted_38 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_41 = { class: "w-full mt-4 table-fixed" }
const _hoisted_42 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_43 = { class: "px-2 py-2" }
const _hoisted_44 = { class: "px-2 py-2 capitalize" }
const _hoisted_45 = { class: "px-2 py-2" }
const _hoisted_46 = { class: "px-2 py-6 md:py-3" }
const _hoisted_47 = { class: "px-2 py-6 md:py-3" }
const _hoisted_48 = { class: "px-2 py-6 md:py-3" }
const _hoisted_49 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_50 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_51 = {
  key: 0,
  class: "w-full mt-4 table-fixed"
}
const _hoisted_52 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_53 = { class: "w-1/5 px-2 py-2" }
const _hoisted_54 = { class: "capitalize" }
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path transform=\"rotate(180, 9, 9)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_18815_11689)\"><rect width=\"18\" height=\"18\" fill=\"white\" fill-opacity=\"0.01\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.22873 1.85285C5.28098 1.80046 5.34306 1.7589 5.41139 1.73055C5.47973 1.70219 5.55299 1.68759 5.62698 1.68759C5.70097 1.68759 5.77423 1.70219 5.84257 1.73055C5.91091 1.7589 5.97298 1.80046 6.02523 1.85285L12.7752 8.60285C12.8276 8.6551 12.8692 8.71717 12.8975 8.78551C12.9259 8.85385 12.9405 8.92711 12.9405 9.0011C12.9405 9.07508 12.9259 9.14835 12.8975 9.21668C12.8692 9.28502 12.8276 9.34709 12.7752 9.39935L6.02523 16.1493C5.91961 16.255 5.77635 16.3143 5.62698 16.3143C5.47761 16.3143 5.33435 16.255 5.22873 16.1493C5.12311 16.0437 5.06377 15.9005 5.06377 15.7511C5.06377 15.6017 5.12311 15.4585 5.22873 15.3528L11.5816 9.0011L5.22873 2.64935C5.17635 2.5971 5.13479 2.53502 5.10643 2.46668C5.07807 2.39835 5.06348 2.32509 5.06348 2.2511C5.06348 2.17711 5.07807 2.10385 5.10643 2.03551C5.13479 1.96717 5.17635 1.9051 5.22873 1.85285V1.85285Z\" fill=\"#6C757D\"></path></g><defs><clipPath id=\"clip0_18815_11689\"><rect width=\"18\" height=\"18\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_64 = {
  href: "https://www.goals-in-therapy.com/",
  target: "_blank",
  class: "text-link"
}
const _hoisted_65 = {
  key: 0,
  class: "w-full mt-4 table-auto"
}
const _hoisted_66 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_67 = { class: "px-2 py-2 capitalize" }
const _hoisted_68 = { class: "px-2 py-2" }
const _hoisted_69 = { class: "px-2 py-2" }
const _hoisted_70 = { class: "px-2 py-2" }
const _hoisted_71 = { class: "px-2 py-2" }
const _hoisted_72 = { class: "px-2 py-2" }
const _hoisted_73 = { class: "px-2 py-2" }
const _hoisted_74 = { class: "px-2 py-2" }
const _hoisted_75 = { class: "px-2 py-2" }
const _hoisted_76 = { class: "px-2 py-2" }
const _hoisted_77 = { class: "px-2 py-2" }
const _hoisted_78 = { class: "px-2 py-6 md:py-3" }
const _hoisted_79 = { class: "px-2 py-6 md:py-3" }
const _hoisted_80 = { class: "px-2 py-6 md:py-3" }
const _hoisted_81 = { class: "px-2 py-6 md:py-3" }
const _hoisted_82 = { class: "px-2 py-6 md:py-3" }
const _hoisted_83 = { class: "px-2 py-6 md:py-3" }
const _hoisted_84 = { class: "px-2 py-6 md:py-3" }
const _hoisted_85 = { class: "px-2 py-6 md:py-3" }
const _hoisted_86 = { class: "px-2 py-6 md:py-3" }
const _hoisted_87 = { class: "px-2 py-6 space-x-4 md:py-3 whitespace-nowrap" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "capitalize px-2 py-6 md:py-3" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { key: 3 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "flex items-center justify-between" }
const _hoisted_95 = { class: "text-3xl font-medium capitalize" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { class: "mt-4" }
const _hoisted_100 = { class: "flex items-center justify-between" }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }

import { ref, onMounted, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import GoalProgressChart from "@/components/charts/GoalProgressChart.vue";
import GoalNotesModal from "@/components/modals/GoalNotesModal.vue";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import RouterButton from "@/components/RouterButton.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import TabGroup from "@/components/TabGroup.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import FeedbackTable from "@/components/tables/FeedbackTable.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { Club, Goal, Student, StudentNote } from "@/types";
import AlertCard from "@/components/AlertCard.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChildOutcomePage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const club = ref({} as Club);
const website_url = process.env.VUE_APP_WEBSITE_URL;

const { user } = storeToRefs(useUserStore());

const isGoalNotesModalOpen = ref(false);

const member = ref({} as Student);
const notes = ref([] as StudentNote[]);

const goals = ref([] as Goal[]);
const goalsArchived = ref([] as Goal[]);
const selectedGoal = ref({} as Goal | null);

const memberFeedbackSurveyData = ref([]);

const goalsTablePage = ref(0);

const isDownloadingReport = ref(false);

let activeDatesFlat: any[] = [];

const goalsTableDatePaginated = computed(() => {
  const page = goalsTablePage.value;
  return activeDatesFlat.slice(page * 5, (page + 1) * 5);
});

const goalsTablePagesLast = computed(() => {
  return Math.ceil(activeDatesFlat.length / 5) - 1;
});

const tabs = ref([
  {
    id: "child_notes",
    name: "Child Notes",
  },
  {
    id: "child_session_feedback",
    name: "Child Session Feedback",
  },
  {
    id: "goal_tracking",
    name: "Goal Tracking",
  },
  {
    id: "evaluation",
    name: "Evaluation",
  },
]);
const selectedTab = ref(tabs.value[0].id);

const GoalTrackingTabs = ref([
  {
    id: "summary",
    name: "Summary",
  },
  {
    id: "goal_tracking",
    name: "Goal Tracking",
  },
  {
    id: "archived_goals",
    name: "Archived Goals",
  },
]);
const selectedGoalTrackingTab = ref(GoalTrackingTabs.value[0].id);

const GraphTableTabs = ref([
  {
    id: "graph",
    name: "Graph",
  },
  {
    id: "table",
    name: "Table",
  },
]);
const selectedGraphTableTab = ref(GraphTableTabs.value[0].id);

const ProgressTabs = ref([
  {
    id: "child_views",
    name: "Child Views",
  },
  {
    id: "parent_views",
    name: "Parent Views",
  },
  {
    id: "facilitator_views",
    name: "Facilitator Views",
  },
]);
const selectedProgressTab = ref(ProgressTabs.value[0].id);
const parentEvalIsDue = ref(false);

let activeTab = "member_notes";

/** Child Goals  */
async function openGoalNotesModal(goal: Goal) {
  selectedGoal.value = goal;
  isGoalNotesModalOpen.value = true;
}

async function listMemberGoals() {
  const response = (await api.students.listParentStudentGoals(user.value.id, member.value.id)).data;
  goals.value = response.goals;
  const activeDates = goals.value.map(goal => {
    return goal.progress.map(progress => {
      return new Date(progress.date.date);
    });
  });

  activeDatesFlat = [
    ...new Set(
      activeDates
        .flat()
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
        .map(date => {
          return new Date(date).toLocaleDateString();
        })
    ),
  ];
}

async function listMemberGoalsArchived() {
  const response = (await api.goals.listMemberArchivedGoalsByClub(club.value.id, member.value.id)).data;
  goalsArchived.value = response.goals;
}

async function getMemberSurveyResults() {
  const id = member.value.id;
  const response = await api.surveys.getMemberSurveyResults(id);
  memberFeedbackSurveyData.value = response.data?.memberSurveryResults?.survey_groups;
}

member.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.getStudentByParent(user.value.id, route.params.member_id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.student;
notes.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.listParentStudentNotes(user.value.id, member.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.notes;
club.value = member.value.clubs[0];

async function getLatestEvalationDatesForClubAndStudent() {
  const feedbackDueDates = await api.surveys.getLatestEvalationDatesForClubAndStudent(club.value.id, member.value.id);
  if (feedbackDueDates.data) {
    parentEvalIsDue.value = feedbackDueDates.data.parent_eval_due;
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listMemberGoals())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listMemberGoalsArchived())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => getMemberSurveyResults())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => getLatestEvalationDatesForClubAndStudent())),
  await __temp,
  __restore()
);

async function getChildGoalReport() {
  isDownloadingReport.value = true;
  const reportUrl = await api.goals.generateChildGoalReport(club.value.id, member.value.id);
  if (reportUrl) {
    isDownloadingReport.value = false;
    window.open(reportUrl.data.report, "_blank");
  }
}

const SMARTSURVEY_EVAL_PARENT_URL =
  process.env.VUE_APP_SMARTSURVEY_EVAL_PARENT_URL + "?uId=" + user.value.id + "&mId=" + member.value.id + "&bcId=" + club.value.id + "&fId=" + club.value.facilitator_id;

onMounted(() => {
  selectedTab.value = route.query.tab as string;

  setInterval(async () => {
    //Only call the following if the current tab on the page is evaluation
    if (activeTab !== "evaluation") {
      return;
    }
    console.log("Polling for evaluation due dates");
    await getLatestEvalationDatesForClubAndStudent();
    await getMemberSurveyResults();
  }, 10000);
});

// Watch for changes to the selectedTab and log the current tab to the console
watch(selectedTab, async newTab => {
  console.log("active tab:", newTab);
  activeTab = newTab;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GoalNotesModal, {
      isOpen: isGoalNotesModalOpen.value,
      goal: selectedGoal.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isGoalNotesModalOpen.value = false))
    }, null, 8, ["isOpen", "goal"]),
    _createElementVNode("div", null, [
      _createVNode(RouterButton, {
        type: "primary",
        to: { path: '/dashboard/children/outcomes' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("back-to")) + " " + _toDisplayString(_ctx.$t("child-outcomes")), 1)
        ]),
        _: 1
      }),
      _createVNode(TitleHeader, {
        class: "mt-6",
        title: `${_unref(capitalize)(member.value.first_name)}${ member.value.middle_name ? ' ' + _unref(capitalize)(member.value.middle_name) : '' } ${_unref(capitalize)(member.value.last_name)}`
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TabGroup, {
        tabs: tabs.value,
        "selected-tab": selectedTab.value,
        onSelect: _cache[1] || (_cache[1] = e => (selectedTab.value = e))
      }, null, 8, ["tabs", "selected-tab"]),
      (selectedTab.value === 'child_notes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("brick-club-notes")), 1)
            ]),
            (notes.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex flex-wrap justify-between w-full px-4 py-2 md:flex-nowrap",
                      key: note.id
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("facilitator")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(note.user.first_name) + " " + _toDisplayString(note.user.last_name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_9, [
                            (note.session.brick_club)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.$t("brick-club")) + ":", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(note.session.brick_club?.name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_11, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("session")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(new Date(note.session.date).toLocaleDateString()), 1)
                          ]),
                          _createElementVNode("span", _hoisted_12, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("visible-to-member-parent-carer")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(note.show_parent ? "Yes" : "No"), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("created")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(new Date(note.created_at).toLocaleString()), 1)
                          ])
                        ]),
                        _hoisted_13,
                        _createVNode(ReadOnlyNote, {
                          content: note.content
                        }, null, 8, ["content"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'child_session_feedback')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (member.value.clubs[0].facilitator.has_smartsurvey_access)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t("child-session-feedback")), 1)
                  ]),
                  _createVNode(AlertCard, {
                    type: "info",
                    class: "mt-6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("play-at-home-banner")), 1),
                        _createElementVNode("div", null, [
                          _createVNode(ExternalLink, {
                            label: _ctx.$t('play-at-home'),
                            href: _unref(website_url) + '/for-home',
                            type: "button",
                            target: "_blank"
                          }, null, 8, ["label", "href"])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("member-session-feedback-helptext-parent")), 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("member-session-feedback-helptext-parent-2")) + " ", 1),
                      _createVNode(_component_router_link, {
                        to: `/dashboard/children/${member.value.id}/edit`,
                        class: "underline text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("here")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createTextVNode(".")
                    ]),
                    (memberFeedbackSurveyData.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                      : _createCommentVNode("", true),
                    _createVNode(FeedbackTable, {
                      if: memberFeedbackSurveyData.value.length,
                      type: "session",
                      surveyData: memberFeedbackSurveyData.value
                    }, null, 8, ["if", "surveyData"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("parent-no-smartsurvey-access")), 1))
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'goal_tracking')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (member.value.clubs[0].facilitator.has_smartsurvey_access)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t("goal-tracking")), 1),
                    _createVNode(DefaultButton, {
                      class: "mt-6",
                      type: "primary",
                      onAction: getChildGoalReport,
                      loading: isDownloadingReport.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("download-report")), 1),
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _createVNode(TabGroup, {
                    tabs: GoalTrackingTabs.value,
                    "selected-tab": selectedGoalTrackingTab.value,
                    onSelect: _cache[2] || (_cache[2] = e => (selectedGoalTrackingTab.value = e))
                  }, null, 8, ["tabs", "selected-tab"]),
                  (selectedGoalTrackingTab.value === 'summary')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-goal-tracking-text")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-goal-tracking-text-2")), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_29, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("table", _hoisted_30, [
                          _createElementVNode("thead", _hoisted_31, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("date-goal-set")), 1),
                              _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("goal")), 1),
                              _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("category")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "border-b border-gray-400",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_35, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(goal.description), 1),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(capitalize)(goal.category)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedGoalTrackingTab.value === 'goal_tracking')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("parent-goal-tracking-text-3")), 1),
                          _createElementVNode("a", {
                            href: _unref(website_url) + '/howto',
                            target: "_blank",
                            class: "text-blue-500 underline hover:text-blue-600"
                          }, _toDisplayString(_ctx.$t("here")), 9, _hoisted_39),
                          _createTextVNode(".")
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("table", _hoisted_41, [
                          _createElementVNode("thead", _hoisted_42, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t("date-goal-set")), 1),
                              _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t("goal")), 1),
                              _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t("category")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "border-b border-gray-400",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_46, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                _createElementVNode("td", _hoisted_47, _toDisplayString(goal.description), 1),
                                _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(capitalize)(goal.category)), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-description")), 1),
                        _createVNode(TabGroup, {
                          tabs: GraphTableTabs.value,
                          "selected-tab": selectedGraphTableTab.value,
                          onSelect: _cache[3] || (_cache[3] = e => (selectedGraphTableTab.value = e))
                        }, null, 8, ["tabs", "selected-tab"]),
                        (selectedGraphTableTab.value === 'graph')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              (goals.value.filter(i => i.status === 'active').length)
                                ? (_openBlock(), _createBlock(GoalProgressChart, {
                                    key: 0,
                                    goals: goals.value.filter(i => i.status === 'active')
                                  }, null, 8, ["goals"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (selectedGraphTableTab.value === 'table')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              (goals.value.filter(i => i.status === 'active').length)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_51, [
                                    _createElementVNode("thead", _hoisted_52, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_53, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["justify-between", { flex: goalsTablePage.value }])
                                          }, [
                                            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("goal")), 1),
                                            (goalsTablePage.value)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goalsTablePage.value--))
                                                }, _hoisted_56))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalsTableDatePaginated), (date, index) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            key: index,
                                            class: "px-2 py-2"
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["justify-between", { flex: index == _unref(goalsTableDatePaginated).length - 1 && goalsTablePage.value !== _unref(goalsTablePagesLast) }])
                                            }, [
                                              _createElementVNode("div", null, _toDisplayString(date), 1),
                                              (index == _unref(goalsTableDatePaginated).length - 1 && goalsTablePage.value !== _unref(goalsTablePagesLast))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (goalsTablePage.value++))
                                                  }, _hoisted_58))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value.filter(i => i.status === 'active'), (goal, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          class: "border-b border-gray-400",
                                          key: index
                                        }, [
                                          _createElementVNode("td", _hoisted_59, _toDisplayString(goal.description), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalsTableDatePaginated), (date, index) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap",
                                              key: index
                                            }, [
                                              (goal.progress.find(i => new Date(i.date.date).toLocaleDateString() === date))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(goal.progress.find(i => new Date(i.date.date).toLocaleDateString() === date).progress), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_61, "-"))
                                            ]))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("no-active-goals")), 1)
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedGoalTrackingTab.value === 'archived_goals')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("archived-goals-helptext-parent")), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-1")), 1),
                          _createElementVNode("a", _hoisted_64, _toDisplayString(_ctx.$t("goals-in-therapy-2")), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t("goals-in-therapy-3")), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-description")), 1),
                        (goalsArchived.value.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_65, [
                              _createElementVNode("thead", _hoisted_66, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.$t("goal")), 1),
                                  _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.$t("categories")), 1),
                                  _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.$t("start-date")), 1),
                                  _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.$t("end-date")), 1),
                                  _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.$t("achieved")), 1),
                                  _createElementVNode("th", _hoisted_72, _toDisplayString(_ctx.$t("start-score")), 1),
                                  _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.$t("end-goal")), 1),
                                  _createElementVNode("th", _hoisted_74, _toDisplayString(_ctx.$t("steps-travelled")), 1),
                                  _createElementVNode("th", _hoisted_75, _toDisplayString(_ctx.$t("sessions")), 1),
                                  _createElementVNode("th", _hoisted_76, _toDisplayString(_ctx.$t("notes")), 1),
                                  _createElementVNode("th", _hoisted_77, _toDisplayString(_ctx.$t("meaningful-progress")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalsArchived.value, (goal, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "border-b border-gray-400",
                                    key: index
                                  }, [
                                    _createElementVNode("td", _hoisted_78, _toDisplayString(goal.description), 1),
                                    _createElementVNode("td", _hoisted_79, _toDisplayString(_unref(capitalize)(goal.category)), 1),
                                    _createElementVNode("td", _hoisted_80, _toDisplayString(new Date(goal.start_date).toDateString()), 1),
                                    _createElementVNode("td", _hoisted_81, _toDisplayString(new Date(goal.end_date).toDateString()), 1),
                                    _createElementVNode("td", _hoisted_82, _toDisplayString(goal.achieved ? "Yes" : "No"), 1),
                                    _createElementVNode("td", _hoisted_83, _toDisplayString(goal.start_score), 1),
                                    _createElementVNode("td", _hoisted_84, _toDisplayString(goal.end_score), 1),
                                    _createElementVNode("td", _hoisted_85, _toDisplayString(goal.steps_travelled), 1),
                                    _createElementVNode("td", _hoisted_86, _toDisplayString(goal.sessions), 1),
                                    _createElementVNode("td", _hoisted_87, [
                                      (goal.notes)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "text-blue-500",
                                            onClick: ($event: any) => (openGoalNotesModal(goal))
                                          }, "View", 8, _hoisted_88))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_89, _toDisplayString(goal.meaningfull_progress), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("no-archived-goals")), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.$t("parent-no-smartsurvey-access")), 1))
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'evaluation')
        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
            (member.value.clubs[0].facilitator.has_smartsurvey_access)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("h2", _hoisted_95, _toDisplayString(_ctx.$t("evaluation")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("progress-parent-intro-1")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("progress-parent-intro-2")), 1)
                  ]),
                  _createVNode(TabGroup, {
                    tabs: ProgressTabs.value,
                    "selected-tab": selectedProgressTab.value,
                    onSelect: _cache[6] || (_cache[6] = e => (selectedProgressTab.value = e))
                  }, null, 8, ["tabs", "selected-tab"]),
                  (selectedProgressTab.value === 'child_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("progress-parent-helptext-child")), 1),
                        (memberFeedbackSurveyData.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "student",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedProgressTab.value === 'parent_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          (parentEvalIsDue.value)
                            ? (_openBlock(), _createBlock(AlertCard, {
                                key: 0,
                                type: "warning",
                                class: "mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("parent-evaluation-nudge-banner-outcomes-page", {
                    child: `${_unref(capitalize)(member.value.first_name)}${ member.value.middle_name ? ' ' + _unref(capitalize)(member.value.middle_name) : '' } ${_unref(capitalize)(member.value.last_name)}`,
                    brick_club: member.value.clubs[0].name,
                  })), 1),
                                    _createVNode(ExternalLink, {
                                      href: SMARTSURVEY_EVAL_PARENT_URL,
                                      type: "button",
                                      class: "ml-4",
                                      label: _ctx.$t('complete-survey')
                                    }, null, 8, ["label"])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "parent",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedProgressTab.value === 'facilitator_views')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("progress-parent-helptext-facilitator")), 1),
                        (memberFeedbackSurveyData.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_102, _toDisplayString(_ctx.$t("arrow-keys-helptext")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(FeedbackTable, {
                          if: memberFeedbackSurveyData.value.length,
                          type: "facilitator",
                          surveyData: memberFeedbackSurveyData.value
                        }, null, 8, ["if", "surveyData"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.$t("parent-no-smartsurvey-access")), 1))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})